import styled from 'styled-components';
import InputCurrency from 'react-currency-input';

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
`;

export const Column = styled.div`
  flex: 1;
`;

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const InnerSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
`;

export const FieldLabel = styled.text`
  font-size: 12px;
  color: #7b7b7b;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 6px;
`;

export const Currency = styled(InputCurrency)`
  -webkit-appearance: none;
  height: ${(props) => props.height || '32px'};
  padding: 0 12px;
  background-color: #fff;
  border: 1px solid ${(props) => (props.error ? '#F27160' : '#ebebeb')};
  border-radius: 3px;
  color: #7b7b7b;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Montserrat', sans-serif;
  width: 100%;

  ${(props) => props.error && 'box-shadow: 0 3px 6px #f2716044;'}

  ::placeholder {
    font-weight: 400;
  }

  transition: 200ms;
`;

export const Error = styled.span`
  padding: 5px;
  font-size: 12px;
  text-align: center;
  color: #F27160;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  width: 100%;
`;

export const WrapperInputCustom = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

